import { ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';

interface ProtectedRouteProps {
  children: ReactNode;
  requireAdmin?: boolean;
  requireBackoffice?: boolean;
}

export const ProtectedRoute = ({ 
  children, 
  requireAdmin = false,
  requireBackoffice = false 
}: ProtectedRouteProps) => {
  const { user, isAdmin, isBackoffice, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) {
      navigate('/auth');
    }
    
    if (!loading && user && requireAdmin && !isAdmin) {
      navigate('/');
    }

    // Backoffice: admin ou backoffice podem acessar
    if (!loading && user && requireBackoffice && !isAdmin && !isBackoffice) {
      navigate('/');
    }
  }, [user, isAdmin, isBackoffice, loading, navigate, requireAdmin, requireBackoffice]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    return null;
  }

  if (requireAdmin && !isAdmin) {
    return null;
  }

  if (requireBackoffice && !isAdmin && !isBackoffice) {
    return null;
  }

  return <>{children}</>;
};
